import { createSelector } from 'reselect';

import { SITE_ROOT_FOLDER_ID_NORDSTROM } from 'lib/const';

import userSelector from './user';

const DEFAULT = SITE_ROOT_FOLDER_ID_NORDSTROM;

// select user's preferred home folder id, user's group's first editable folder id, or default to nordstrdom site root
export default createSelector(
  userSelector,
  ({ permissions, preferences }) =>
    preferences?.homeFolderId || permissions?.folders?.edit?.[0] || DEFAULT
);
